import { useMutation, useQuery } from "@tanstack/react-query";
import { getSKUMovementEnquiry } from "services/data.report.service";
import { TableCard } from "ui-components/Layout";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { skuMovementEnquiryColumns } from "./columns";
import { useState } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { CSVLink } from "react-csv";
import { Texts } from "ui-components/Form";
import { Grid } from "@mui/material";
import { scan } from "services/data.test.service";
import { scanDelete } from "services/data.test.service";
import { scanGet } from "services/data.test.service";
import { scanConfirm } from "services/data.test.service";
import { CustomDateRangePicker } from "ui-components/CustomInput";
import dayjs from "dayjs";
import { Error_, Success, Error } from "ui-components/Alert";
import { LoadingDialog } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";
import { ExportButton, EmailButton } from "ui-components/Button";
import { ExportDialog } from "ui-components/Alert";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";

function SKUMovementEnquiry() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const date = dayjs(new Date()).format("YYYY-MM-DD");
  const sevenDaysBefore = dayjs(new Date()).subtract(1, "day").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(sevenDaysBefore);
  const [endDate, setEndDate] = useState(date);
  const { downloadCsv, isDownloading } = useCsvDownloadHook();
  const { refetch, isFetching } = useQuery({
    queryKey: ["sku-movement-enquiry", { customerCode }],
    queryFn: () => getSKUMovementEnquiry({ customerCode, startDate, endDate }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => {
      setData(data.data.data);
      setFilteredData(data.data.data);
    },
    onError: () => {},
  });
  const exportPermission =
    allowAll ||
    (Boolean(permissions["SKU Movement_Report"]) &&
      permissions["SKU Movement_Report"].findIndex((b) => b === "export") !== -1);

  const customProps = { startDate, setStartDate, endDate, setEndDate };

  const onFetch = () => {
    setAlert(null);
    const valid =
      dayjs(endDate).isSame(dayjs(startDate)) || dayjs(endDate).isAfter(dayjs(startDate));
    if (!valid) {
      setAlert(<Error_ content="Start date cannot greater than end date" onChange={setAlert} />);
      return;
    }
    if (dayjs(date).isBefore(endDate)) {
      setAlert(<Error_ content="End date cannot greater than today date" onChange={setAlert} />);
      return;
    }
    refetch();
  };

  const handleFilterRowsChange = (filteredData) => {
    setFilteredData(filteredData);
  };

  const onSuccess = (data) => {
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const onError = (data) => {
    setAlert(<Error data={data} onChange={setAlert} />);
  };

  // useQuery({
  //   queryKey: ["scan-get"],
  //   queryFn: () => scanGet({ carrier: "" }),
  //   onSuccess: (data) => {
  //     setTrackings(data.data.data);
  //   },
  // });

  // const scanMutation = useMutation(scan, {});
  // const deleteMutation = useMutation(scanDelete, {});
  // const confirmMutation = useMutation(scanConfirm, {});
  // const [trackings, setTrackings] = useState([]);
  // const [number, setNumber] = useState([]);
  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {isDownloading && <ExportDialog />}
      {alert && <MDBox sx={{ my: 3 }}>{alert}</MDBox>}

      <TableCard sx={{ my: 3 }}>
        <MDBox margin="1rem 0 0 1rem">
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <CustomDateRangePicker {...customProps} />
            </Grid>
            <Grid item xs={3}>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => {
                  onFetch();
                }}
              >
                search
              </MDButton>
              {/* <MDButton sx={{ marginLeft: "1rem" }} variant="gradient" color="info" disabled={!exportPermission}>
                <CSVLink style={{ color: "white" }} filename={`SKU_Movement`} data={filteredData}>
                  export
                </CSVLink>
              </MDButton> */}
              <MDButton
                sx={{ marginLeft: "1rem" }}
                variant="gradient"
                color="info"
                disabled={!exportPermission}
                onClick={() => {
                  const filename = `${customerCode}_${dayjs(new Date()).format(
                    "YYYYMMDD-HHmm"
                  )}_SKUMovement`;
                  downloadCsv(
                    filename,
                    filteredData.map((x) => {
                      const {
                        openingQuantityStr,
                        inQuantityStr,
                        outQuantityStr,
                        adjustQuantityStr,
                        closingQuantityStr,
                        ...data
                      } = x;
                      return data;
                    })
                  );
                }}
              >
                export
              </MDButton>
              {/* <ExportButton
                variant="gradient"
                color="info"
                sx={{ marginLeft: "1rem" }}
                filename={`SKU_Movement`}
                fileData={filteredData}
                disabled={!exportPermission}
              /> */}
            </Grid>
            <Grid item xs={5}>
              <EmailButton
                variant="gradient"
                color="info"
                filename={`${customerCode}_${dayjs(new Date()).format(
                  "YYYYMMDD-HHmm"
                )}_SKUMovement`}
                fileData={filteredData}
                onSuccess={onSuccess}
                onError={onError}
                customerCode={customerCode}
              />
            </Grid>
          </Grid>
        </MDBox>

        <BasicTable
          data={data}
          columns={skuMovementEnquiryColumns}
          onFilterRowsChange={handleFilterRowsChange}
        />
      </TableCard>
      {/* <TableCard sx={{ my: 3 }}>
        <Grid container spacing={3}>
          <Grid item sx={6}>
            <Texts
              field={{ name: "number", label: "Number", value: number, maxLength: 20 }}
              onChange={({ target }) => {
                setNumber(target.value);
              }}
            />
          </Grid>
          <Grid item sx={6}>
            <MDButton
              color="info"
              variant="gradient"
              onClick={() => {
                scanMutation.mutate(
                  { carrier: "", tracking_number: number },
                  {
                    onSuccess: (data) => {
                      setTrackings([...trackings, data.data.data]);
                    },
                  }
                );
              }}
            >
              submit
            </MDButton>
          </Grid>
        </Grid>
        <ul>
          {trackings.map((t, index) => (
            <div>
              {t.tracking_number}{" "}
              <button
                onClick={() => {
                  deleteMutation.mutate(
                    { ...t },
                    {
                      onSuccess: (data) => {
                        const tracking_ = trackings.splice(index, 1);
                        setTrackings(
                          trackings.filter(
                            (x) => x.tracking_number !== tracking_[0].tracking_number
                          )
                        );
                      },
                    }
                  );
                }}
              >
                delete
              </button>
            </div>
          ))}
        </ul>
        <button
          onClick={() => {
            confirmMutation.mutate({ items: trackings });
          }}
        >
          confirm
        </button>
      </TableCard> */}
    </ListLayout>
  );
}

export default SKUMovementEnquiry;
